import React, { useEffect, useState } from 'react';
import { get, find, isNull, round, filter } from 'lodash';
import { connect } from 'react-redux';

import { savePlanSelection } from '../../store/signup/signupAction';
import PlanSelect, { flavourSelectModel } from '../../components/PlanSelect';
import { MAX_NO_OF_USERS, MIN_NO_OF_USERS, MAX_FILE_STORAGE, MIN_FILE_STORAGE } from "../../utilities/constants"
/**
 * Price calculator component
 * @param {*} param0
 */
const PriceCalculator = ({
    pricingData,
    setViewModal,
    savePlanSelection,
    selectedPlan,
}) => {
    const [userCost, setUserCost] = useState(5);
    const [userCount, setUserCount] = useState(11);
    const [recommendedSettings, setrecommendedSettings] = useState({});
    const [serverOptions, setServerOptions] = useState([]);
    const [selectedServer, setSelectedServer] = useState({});
    const [selectedStorage, setSelectedStorage] = useState(22);

    useEffect(() => {
        const dispData = JSON.parse(
            get(pricingData, 'core.0.component_disp_json')
        );
        const flavor = get(dispData, 'flavor_component_id');

        if (get(selectedPlan, 'flavor.value') !== flavor) {
            const selectedFlavor = find(
                get(pricingData, 'flavor', []),
                (currentFlavor) => {
                    return (
                        currentFlavor.component_id ===
                        get(selectedPlan, 'flavor.value')
                    );
                }
            );

            if (get(selectedFlavor, 'component_id')) {
                setSelectedStorage(get(selectedPlan, 'storage'));
                setUserCount(get(selectedPlan, 'users'));
                setTimeout(() => {
                    setSelectedServer({
                        value: selectedFlavor.component_id,
                        label: selectedFlavor.component_name,
                        price: get(
                            selectedFlavor,
                            'scales.0.scale_unitPrice',
                            0
                        ),
                        description: selectedFlavor.component_description,
                    });
                }, 30);
            }
        }
    }, [
        pricingData,
        setSelectedServer,
        setSelectedStorage,
        setUserCount,
        selectedPlan,
    ]);

    useEffect(() => {
        const recommendedScale = find(
            get(pricingData, 'user.0.scales'),
            (elem) => {
                return (
                    userCount >= elem.scale_minRange &&
                    (userCount <= elem.scale_maxRange ||
                        isNull(elem.scale_maxRange))
                );
            }
        );
        setrecommendedSettings(recommendedScale);
        setUserCost(get(recommendedScale, 'scale_unitPrice', 5));
    }, [userCount, setrecommendedSettings, pricingData, setUserCost]);
    /**
     * Gets user scale for component
     * @param {*} scales
     * @param {*} flavor
     */
    const getUserscale = (scales, flavor) => {
        const userScale = find(scales, (scale) => {
            const config = JSON.parse(
                get(scale, 'scale_recommended_config', '{}')
            );
            return config.flavor_component_id === flavor.component_id;
        });
        return userScale;
    };
    useEffect(() => {
        const flavors = get(pricingData, 'flavor', []);
        const dispData = JSON.parse(
            get(pricingData, 'core.0.component_disp_json')
        );
        const coreFlavorId = get(dispData, 'flavor_component_id');

        const selectOptions = filter(flavors, (flavor) => {
            return (
                flavor.is_active === 'Yes' &&
                flavor.is_private === 'No' &&
                flavor.component_id !== coreFlavorId
            );
        }).map((flavor, index) => {
            const description = JSON.parse(flavor.component_disp_json);
            const scale = getUserscale(
                get(pricingData, 'user[0].scales', []),
                flavor
            );
            return {
                key: `${flavor.component_id}_${index}`,
                value: flavor.component_id,
                label: flavor.component_name,
                minum_storage: get(
                    JSON.parse(get(scale, 'scale_recommended_config', '{}')),
                    'min_user_storage',
                    2
                ),
                price: get(flavor, 'scales.0.scale_unitPrice', 0),
                description: flavor.component_description,
                scale_minRange: scale.scale_minRange,
                scale_maxRange: scale.scale_maxRange,
                layout: flavourSelectModel(
                    flavor.component_name,
                    scale.scale_minRange,
                    scale.scale_maxRange,
                    null,
                    `${get(description, '[0].count', null)} Core vCPU`,
                    `${get(description, '[1].count', null)} GB RAM`,
                    get(flavor, 'scales[0].scale_unitPrice', null),
                    'month'
                ),
            };
        });
        setServerOptions(selectOptions);
    }, [pricingData, setServerOptions]);

    useEffect(() => {
        const recommended = JSON.parse(
            get(recommendedSettings, 'scale_recommended_config', '{}')
        );

        const recommendeFlavor = find(
            get(pricingData, 'flavor', []),
            (flavor) => {
                return flavor.component_id === recommended.flavor_component_id;
            }
        );
        // setRecommendedStorage(get(recommended, 'min_user_storage', 2));

        if (get(recommendeFlavor, 'component_id')) {
            setSelectedServer({
                value: recommendeFlavor.component_id,
                label: recommendeFlavor.component_name,
                price: get(recommendeFlavor, 'scales.0.scale_unitPrice', 0),
                description: recommendeFlavor.component_description,
            });
        }
    }, [
        recommendedSettings,
        setSelectedServer,
        pricingData,
        // setRecommendedStorage,
    ]);
    const checkMinimumFIleStorage = (value, noOfUsers = userCount) => {
        if (noOfUsers * 2 > value) {
            if ((noOfUsers * 2) <= MAX_FILE_STORAGE) {
                setSelectedStorage(noOfUsers * 2);
            } else {
                setSelectedStorage(MAX_FILE_STORAGE);
            }
        } else if (value < MIN_FILE_STORAGE) {
            setSelectedStorage(MIN_FILE_STORAGE);
        }
    }
    const handleNumberOfUser = value => {
        if (Number(value) <= MAX_NO_OF_USERS) {
            setUserCount(value);
            checkMinimumFIleStorage(selectedStorage, value);
        }
    }

    /**
     * Process custom config to api accaptable form
     */
    const processCustomConfig = () => {
        const monthlyPrice = round(
            get(pricingData, 'storage.0.scales.0.scale_unitPrice') *
            selectedStorage +
            get(selectedServer, 'price') +
            userCost * userCount,
            2
        );
        const saveData = {
            flavor: selectedServer,
            users: userCount,
            storage: selectedStorage,
            monthlyPrice,
        };
        savePlanSelection(saveData);
        setViewModal(false);
    };
    return (
        <div>
            <div className="form-group">
                <label>
                    Expected Number of Users (${userCost} / User){' '}
                    <strong>${userCost * userCount}</strong>
                </label>
                <input
                    placeholder="No. of users"
                    type="number"
                    onBlur={(e) => e.target.value < MIN_NO_OF_USERS && setUserCount(MIN_NO_OF_USERS)}
                    onChange={(e) => handleNumberOfUser(e.target.value)}
                    value={userCount}
                    min="11"
                    class="form-control"
                />
                <p className="note">
                    You will be charged only for the activated users.
                </p>
            </div>
            <div className="form-group">
                <label>
                    Server Configuration
                    <strong>${get(selectedServer, 'price')}/Month</strong>
                </label>
                <PlanSelect
                    serverOptions={serverOptions}
                    placeholder="Select Industry"
                    className="custom-select"
                    changeEvent={(data) => {
                        setSelectedServer(data);
                    }}
                    value={[selectedServer]}
                />
            </div>
            <div className="form-group">
                <label>
                    File Storage ($
                    {get(pricingData, 'storage.0.scales.0.scale_unitPrice')}/
                    {get(pricingData, 'storage.0.scales.0.scale_unit')})
                    <strong>
                        $
                        {round(
                            get(
                                pricingData,
                                'storage.0.scales.0.scale_unitPrice'
                            ) * selectedStorage,
                            2
                        )}
                    </strong>
                </label>
                <div className="input-add-subtract">
                    <input
                        type="number"
                        onChange={(e) => Number(e.target.value) <= MAX_FILE_STORAGE && setSelectedStorage(e.target.value)}
                        onBlur={(e) => checkMinimumFIleStorage(e.target.value)}
                        value={selectedStorage}
                        min={get(
                            pricingData,
                            'storage.0.scales.0.scale_minBuyable'
                        )}
                        class="form-control"
                    />
                    <p className="note">
                        Recommended minimum storage based on number of users.
                    </p>
                </div>
            </div>

            <div className="calculated-cost">
                {/* <span>Expected Max Monthly Cost</span> */}
                <span>
                    Expected Monthly Cost<br></br>
                    <strong>
                        $
                        {round(
                            get(
                                pricingData,
                                'storage.0.scales.0.scale_unitPrice'
                            ) *
                            selectedStorage +
                            get(selectedServer, 'price') +
                            userCost * userCount,
                            2
                        )}
                    </strong>
                </span>
            </div>
            <div className="align-right">
                <button
                    className="btn-ghost mr-15"
                    onClick={() => setViewModal(false)}
                >
                    Cancel
                </button>
                <button className="btn-tertiary" onClick={processCustomConfig}>
                    Select
                </button>
            </div>
        </div>
    );
};

const mapDispatchToProps = {
    savePlanSelection,
};
const mapStateToProps = (store, props) => ({
    otpVerified: get(store, 'signupReducer.otpVerified', false),
    pricingData: get(store, 'signupReducer.pricingData', {}),
    selectedPlan: get(store, 'signupReducer.planDetails', {}),
});

export default connect(mapStateToProps, mapDispatchToProps)(PriceCalculator);
